// @ts-nocheck
import React from 'react';

const MsrPage = () => {
  return (
    <section className="pt-2 pb-10">
      <div className="container md:px-[65px]">
        <div className="flex flex-col-reverse text-white md:flex-row">
          <div className="relative md:w-3/5 bg-[#A81414] md:h-[350px] px-6 py-2 md:p-8 md:rounded-tl-xl rounded-bl-xl max-md:rounded-br-xl">
            <h2 className="py-3 text-xl font-bold text-justify uppercase md:hidden md:text-4xl hyphens-auto">
              <div>Молодіжний</div>
              <div>Салезіянський Рух</div>
            </h2>
            <h2 className="hidden py-3 text-xl font-bold text-justify uppercase md:block md:text-4xl hyphens-auto">Молодіжний Салезіянський Рух</h2>
            <div className="pt-3 pb-3 max-md:leading-5 md:pl-8 hyphens-auto">
              Молодіжний Салезіянський Рух (МСР) - це рух, який об’єднує всю молодь і молодіжні асоціації, що присутні в Салезіянських Домах та поза ними, які визнають себе приналежними до салезіянської духовності, перебуваючи у салезіянському вихованні.
            </div>
            <div className="pt-3 pb-3 md:pl-8 hyphens-auto max-md:leading-5">
              МСР офіційно розпочався у 1988 році у сторіччя смерті святого Івана Боско.
            </div>
          </div>
          <div className="relative md:w-2/5">
            <div class="hidden md:block absolute md:top-1/2 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[20px] border-b-[20px] border-l-[10px]
              md:border-t-[175px] md:border-b-[175px] md:border-l-[50px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
            </div>
            <img
              className="md:h-[350px] object-cover object-right rounded-tr-xl md:rounded-br-xl rounded-tl-xl md:rounded-tl-none"
              src="/images/msrpage.JPG"
              alt=""
            />
          </div>
        </div>
        <h3 className="max-md:pb-3 py-6 text-xl md:text-4xl font-bold text-justify uppercase hyphens-auto text-[#A81414]">Цей рух має два елементи ідентичності: </h3>
        <div className="md:px-16">
          <ul className="flex flex-col gap-5 text-justify hyphens-auto ">
            <li>
              посилання на салезіянську молодіжну духовність (СМД) і зв’язок між групами, асоціаціями та молодіжними реаліями, які нею надихаються. Поряд із зустрічами та діяльністю кожної групи чи місцевої реальності, Провінційні, національні, міжнародні та всесвітні зустрічі молоді, літургійні святкування та салезіянські свята, а також навчання аніматорів визнаються сильними моментами досвіду спільноти. На територіальному рівні Провінція координує присутність Салезіанської Родини на своїй території та забезпечує включення МСР у контекст салезіанського виховно-душпастирського проекту (ВДП).
            </li>
          </ul>
        </div>
        <h3 className="max-md:pb-3  py-6 text-xl md:text-4xl font-bold text-justify uppercase hyphens-auto text-[#A81414]">МСР супроводжує молодь</h3>
        <div className="text-justify md:px-16 hyphens-auto">
          МСР супроводжує хлопців та дівчат, як на особистому так і на спільнотному рівні. Все це для того, аби, як сказав отець Боско, вони могли бути «добрими християнами, чесними громадянами і в майбутньому гідними мешканцями Неба». Привілейованими сферами зростання для МСР є апостольсько-духовна, особиста, громадська, соціально-політична відданість. Місцевий рівень є фундаментальним і незамінним: це місце, де молода людина відчуває і переживає молодіжну салезіянську духовність у повсякденному житті з багатством груп, діяльності та інтересів іншої молоді. На Провінційному, національному та міжнародному рівнях періодично проводяться широкі ініціативи, які дають молоді можливість подолати кордони їхньої місцевої реальності та дозволяють насолоджуватися радістю «відчувати себе частиною великої спільноти» та поділяти однакові цінності молодіжної Салезіянської Духовності .
        </div>
      </div>
    </section>
  );
};

export default MsrPage;
